if (!customElements.get('hh-pdp-sticky')) {
  customElements.define('hh-pdp-sticky', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controls = this.querySelector('.cart_add_wrapper');
      if (!this.controls) return;

      this.initialHeight = this.style.height;
      this.naturalHeight = 0;
      this.needsMeasure = true;
      this.frame = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const section = this.closest('.shopify-section') || this.parentElement;
      const schedule = () => this.schedule();
      const remeasure = () => this.schedule(true);

      window.addEventListener('scroll', schedule, { ...options, passive: true });
      window.addEventListener('resize', remeasure, options);
      window.addEventListener('pageshow', remeasure, options);
      window.addEventListener('hh:selling-plan:change', remeasure, options);
      document.addEventListener('load', remeasure, { ...options, capture: true });
      document.addEventListener('shopify:section:load', remeasure, options);
      document.addEventListener('shopify:section:reorder', remeasure, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(this)) this.cleanup();
      }, options);
      section.addEventListener('change', remeasure, options);
      document.addEventListener('shopify:block:select', event => {
        if (event.target.contains(this)) {
          this.editorSelected = true;
          remeasure();
        }
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (event.target.contains(this)) {
          this.editorSelected = false;
          remeasure();
        }
      }, options);

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(remeasure);
        new Set([this, this.controls, section, document.body]).forEach(element => {
          this.resizeObserver.observe(element);
        });
      }
      if (document.fonts) {
        document.fonts.addEventListener('loadingdone', remeasure, options);
      }
      this.schedule(true);
    }

    schedule(measure = false) {
      if (!this.controller || !this.isConnected) return;
      this.needsMeasure = this.needsMeasure || measure;
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    }

    update() {
      if (!this.controller || !this.isConnected) return;
      const configuredBreakpoint = Number(this.dataset.breakpoint);
      const breakpoint = configuredBreakpoint > 0 ? configuredBreakpoint : 746;
      if (window.innerWidth > breakpoint || this.editorSelected) {
        this.removeAttribute('is-sticky');
        this.style.height = this.initialHeight;
        this.needsMeasure = true;
        return;
      }

      if (this.needsMeasure || !this.hasAttribute('is-sticky')) {
        this.removeAttribute('is-sticky');
        this.style.height = this.initialHeight;
        this.naturalHeight = this.getBoundingClientRect().height;
        this.needsMeasure = false;
      }

      const original = this.getBoundingClientRect();
      const shouldStick = this.naturalHeight > 0 && original.width > 0 && original.bottom <= 0;
      if (shouldStick) {
        this.style.height = `${this.naturalHeight}px`;
        this.setAttribute('is-sticky', '');
      } else {
        this.removeAttribute('is-sticky');
        this.style.height = this.initialHeight;
      }
    }

    cleanup() {
      if (!this.controller) return;
      this.controller.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.editorSelected = false;
      this.removeAttribute('is-sticky');
      this.style.height = this.initialHeight;
    }

    disconnectedCallback() {
      this.cleanup();
    }
  });
}
